// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/screens/Screen5/styles.scss
// module id = 388
// module chunks = 0